import { Directive, ElementRef, EventEmitter, HostListener, Output, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { timeout } from '../tools/event-tool';

@Directive({
	standalone: true,
	selector: '[swipeUpDown]'
})
export class SwipeUpDownDirective {
	// overlay_management: ElementRef<HTMLDivElement>;
	prevPosition = 0;
	overlayHeight = 0;
	scrollTop = 0;
	isPartOfHeader = false;
	scrollElememt: Element;
	@Output() swipeHide = new EventEmitter();
	subs: Subscription[];
	constructor(
		private renderer: Renderer2,
		private overlay_management: ElementRef<HTMLDivElement>
	) {}
	@HostListener('touchstart', ['$event']) onTouchstart(event) {
		const scrollElememt = this.overlay_management.nativeElement.getElementsByClassName('overflow-auto')[0];
		this.isPartOfHeader =
			event?.srcElement?.tagName == 'HEADER' || event.srcElement.getElementsByTagName('header')?.length;
		this.scrollTop = scrollElememt?.scrollTop ?? 0;
		if (this.scrollTop > 0 && !this.isPartOfHeader) return;
		this.prevPosition = event.changedTouches[0].clientY;
		this.overlayHeight = this.overlay_management.nativeElement.offsetHeight;
	}

	@HostListener('touchmove', ['$event']) onTouchmove(event) {
		if (event?.target?.type == 'range') return;
		if (this.scrollTop > 0 && !this.isPartOfHeader) return;
		const offsetHeight = this.overlay_management.nativeElement.offsetHeight;
		const diffSize = this.prevPosition - event.changedTouches[0].clientY;
		let calHeight = offsetHeight + diffSize;
		calHeight = calHeight > this.overlayHeight ? this.overlayHeight : calHeight;
		if (offsetHeight < this.overlayHeight || (offsetHeight === this.overlayHeight && diffSize < 0)) {
			//if (calHeight < this.overlayHeight)
			this.renderer.setStyle(this.overlay_management.nativeElement, 'height', `${calHeight}px`);
		}
		this.prevPosition = event.changedTouches[0].clientY;
	}

	@HostListener('touchend', ['$event']) onTouchend() {
		const height = this.overlay_management.nativeElement.offsetHeight;
		const disableHide = this.overlay_management.nativeElement.classList.contains('disable-hide');

		if (!disableHide && height < this.overlayHeight / 1.2) {
			//  this.overlayService.hideOverlay();
			this.swipeHide.emit(true);
			timeout(() => {
				this.renderer.removeStyle(this.overlay_management.nativeElement, 'height');
			}, 500);
		} else this.renderer.removeStyle(this.overlay_management.nativeElement, 'height');
	}
}
